import React, { useEffect, useContext, useState } from "react";
import { Button, Card, Col, Container, Form, Image, Row, Stack } from "react-bootstrap";
import { errorAlert, successAlert } from "../components/common/Alert";
import { Loader } from "../components/common/Loader";
import { AuthContext } from "../states/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../services/Networkcall";
import InputField from "../components/common/InputField";
import { FiEye, FiEyeOff } from "react-icons/fi";

export const ResetPassword = () => {
    const { setUserLoggedIn, setUserProfileData } = useContext(AuthContext);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [inData, setInData] = useState({ "password": "", "confirmPassword": "", "token": "" });
    const [error, setError] = useState({ "password": "", "confirmPassword": "", "token": "" });
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    useEffect(() => {
        const token = searchParams.get('token');
        setInData((prev) => ({ ...prev, ["token"]: token }));
    }, [])


    const togglePasswordVisibility = () => setShowPassword(!showPassword);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword(!showConfirmPassword);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        setInData((prev) => ({ ...prev, [name]: value }));
        setError((prev) => ({ ...prev, [name]: "" }));
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        let isValid = true;
        const newErrors = { password: "", confirmPassword: "", token: "" };

        if (!inData.password) {
            newErrors.password = "Required";
            isValid = false;
        }

        if (!inData.confirmPassword) {
            newErrors.confirmPassword = "Required";
            isValid = false;
        } else if (inData.password !== inData.confirmPassword) {
            newErrors.confirmPassword = "Password mismatch";
            isValid = false;
        }

        if (!inData.token) {
            errorAlert({ message: "Something went wrong please try again later" });
            isValid = false;
        }

        setError(newErrors);

        if (isValid) {
            setLoading(true);
            const data = {
                "token": inData.token,
                "newPassword": inData.password
            }

            try {

                const res = await resetPassword(data);

                if (res.success) {
                    setUserLoggedIn(true);
                    setUserProfileData(res.data);
                    localStorage.setItem("userLoggedIn", "true");
                    localStorage.setItem("userAuthToken", `${res.data.token}`);
                    localStorage.setItem("userProfileData", JSON.stringify(res.data));
                    successAlert({ message: res.message })
                    navigate("/login", { replace: true });
                } else {
                    errorAlert({ message: res.message });
                }
            } catch (err) {
                errorAlert({ message: err?.response?.data?.message || err?.message || 'something went wrong.' })
            } finally {
                setLoading(false);
            }
        }
    };


    return (
        <>

            <div className="login-wrapper">
                <Loader show={loading} />
                <Card className="login-card">
                    <div className="login-header">
                        <h3 className=" ">TruckTuck <span>PRO</span></h3>
                        <h6 className="mb-0 mt-2 fw-bold">Reset Password</h6>
                    </div>

                    <Form onSubmit={submitHandler}>
                        <Stack gap={3} direction="vertical">

                            

                            <InputField
                                    type={showPassword ? "text" : "password"}
                                    name={"password"}
                                    label={"Password"}
                                    id={"PasswordInput"}
                                    className="bg-white rounded-2 "
                                    size={"md"}
                                    placeholder={"Password"}
                                    onChange={inputHandler}
                                    feedback={error.password}
                                    isvalid={!!error.password}
                                    value={inData.password}
                                    endIcon={
                                        !error.password ?
                                            showPassword ? (
                                                <FiEyeOff className="text-secondary cursor-pointer" onClick={togglePasswordVisibility} />
                                            ) : (
                                                <FiEye className="text-secondary cursor-pointer" onClick={togglePasswordVisibility} />
                                            ) : ""
                                    }
                                />

                                <InputField
                                    type={showConfirmPassword ? "text" : "password"}
                                    name={"confirmPassword"}
                                    label={"Confirm Password"}
                                    id={"PasswordInput"}
                                    className="bg-white rounded-2"
                                    size={"md"}
                                    placeholder={"Confirm Password"}
                                    onChange={inputHandler}
                                    feedback={error.confirmPassword}
                                    isvalid={!!error.confirmPassword}
                                    value={inData.confirmPassword}
                                    endIcon={
                                        !error.confirmPassword ?
                                            showConfirmPassword ? (
                                                <FiEyeOff className="text-secondary cursor-pointer" onClick={toggleConfirmPasswordVisibility} />
                                            ) : (
                                                <FiEye className="text-secondary cursor-pointer" onClick={toggleConfirmPasswordVisibility} />
                                            ) : ""
                                    }
                            />
                            
                            <Button type="submit" className="login-btn w-100 mt-2 ">
                                submit
                            </Button>
                        </Stack>
                    </Form>
                </Card>

            </div>

        </>

    );
};
